import DispatchConstants from '../constants/DispatchConstants';

export const API_LIST_ITEM_SOURCE = {
  CLIENT: 'client',
  MIDDLEWARE: 'middleware',
} as const;

export type ApiListItemType = {
  endpoint: string;
  source: typeof API_LIST_ITEM_SOURCE.CLIENT | typeof API_LIST_ITEM_SOURCE.MIDDLEWARE;
};

const initState = (): {
  apiList: Array<ApiListItemType>;
  logCountMap: () => Record<string, { count: number; client: number; middleware: number }>;
} => ({
  apiList: [],
  logCountMap: function () {
    // NOTE: restart `node` since connected to `middleware`
    const { apiList } = this;

    const res: Record<string, { count: number; client: number; middleware: number }> = {};

    apiList.forEach(({ endpoint, source }) => {
      if (res[endpoint]) {
        res[endpoint].count += 1;
      } else {
        res[endpoint] = {
          count: 1,
          client: 0,
          middleware: 0,
        };
      }

      res[endpoint][source] += 1;
    });

    // eslint-disable-next-line no-console
    console.table(res);

    return res;
  },
});

const devTool = (
  state = initState(),
  action: {
    type?: string;
    payload?: Record<string, unknown> | ApiListItemType;
  } = {},
) => {
  const { type, payload } = action;

  if (type === DispatchConstants.ADD_DEV_TOOL_API_LIST) {
    return { ...state, apiList: [...state.apiList, payload as ApiListItemType] };
  }

  if (type === DispatchConstants.UPDATE_DEV_TOOL) {
    return { ...state, ...(payload as Record<string, unknown>) };
  }
  return state;
};

export default devTool;
